import ViewTicket from "./ViewTicket";

export default ViewTicket